import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-ballot-dashboard',
    templateUrl: './ballot-dashboard.component.html',
    styleUrl: './ballot-dashboard.component.scss',
    standalone: false
})
export class BallotDashboardComponent {

  constructor(private router: Router) {}

  navigateTo(type: string): void {
    switch (type) {
      case 'CIB':
        this.router.navigate(['/ballots/cib/create-ballot']);
        break;
      case 'SR':
        this.router.navigate(['/ballots/srs/create-ballot']);
        break;
      case 'IEC':
        this.router.navigate(['/ballots/iec/create-ballot']);
        break;
      default:
        break;
    }
  }
}
